import React, { useState } from "react";

const Meeting = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    date: "",
    time: "",
    purpose: "",
  });

  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isValid = form.name && form.email && form.date && form.time;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValid) return;

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
      setForm({
        name: "",
        email: "",
        date: "",
        time: "",
        purpose: "",
      });
    }, 2500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-white to-gray-200 flex items-center justify-center p-6">

      <div className="w-full max-w-5xl bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden border border-gray-200">

        <div className="relative h-[200px] flex items-center justify-center">

          <img
            src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg"
            className="absolute w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-black/60"></div>

          <div className="relative text-center text-white px-6">
            <h1 className="text-4xl md:text-5xl font-bold">
              Book a Meeting
            </h1>
            <p className="text-gray-200 mt-2 text-sm md:text-base">
              Let’s discuss your project & grow your business
            </p>
          </div>

        </div>

        <div className="grid md:grid-cols-2 gap-10 p-10">

          <div className="space-y-6">

            <h2 className="text-3xl font-bold text-gray-900">
              Let’s Build Something Great 🚀
            </h2>

            <p className="text-gray-600 leading-relaxed">
              Schedule a free consultation with our experts.
              We help businesses grow with modern web solutions,
              marketing strategies, and scalable technology.
            </p>

            <div className="space-y-3 text-gray-700">
              <p>✔ Free 30–60 min consultation</p>
              <p>✔ Business & tech strategy discussion</p>
              <p>✔ Growth roadmap planning</p>
              <p>✔ No hidden charges</p>
            </div>

            <div className="p-5 bg-gradient-to-r from-gray-50 to-gray-100 border rounded-2xl">
              <p className="text-sm text-gray-500">
                ⭐ Trusted by startups & businesses for digital growth solutions
              </p>
            </div>

          </div>

          <div className="bg-white border rounded-2xl p-6 shadow-lg">

            <h2 className="text-xl font-semibold mb-4 text-gray-900">
              Schedule Your Meeting
            </h2>

            {success && (
              <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-lg animate-pulse">
                🎉 Meeting booked successfully!
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">

              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Full Name *"
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-black outline-none"
              />

              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email Address *"
                className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-black outline-none"
              />

              <div className="grid grid-cols-2 gap-3">

                <input
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  className="p-3 border rounded-lg"
                />

                <input
                  type="time"
                  name="time"
                  value={form.time}
                  onChange={handleChange}
                  className="p-3 border rounded-lg"
                />

              </div>

              <textarea
                name="purpose"
                value={form.purpose}
                onChange={handleChange}
                rows="4"
                placeholder="Tell us about your project..."
                className="w-full p-3 border rounded-lg"
              />

              <button
                type="submit"
                disabled={!isValid}
                className={`w-full py-3 rounded-lg font-semibold transition ${
                  isValid
                    ? "bg-black text-white hover:bg-gray-800"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              >
                Book Meeting →
              </button>

            </form>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Meeting;